export interface SelectType {
  value: number;
  label: string;
}

export const typeValue: SelectType[] = [
  {value: -1, label: "전체"},
  {value: 0, label: "회전기기"},
  {value: 1, label: "장치류"},
  {value: 2, label: "전기설비"},
  {value: 3, label: "계장계기류"},
  {value: 4, label: "배관"},
  {value: 5, label: "밸브"},
  {value: 6, label: "감지설비"},
  {value: 7, label: "기타"},
];
export const changeValue: SelectType[] = [
  {value: -1, label: "전체"},
  {value: 0, label: "정상변경"},
  {value: 1, label: "임시변경"},
  {value: 2, label: "비상변경"},
];

export const daysOfWorkValue: SelectType[] = [
  {value: 0, label: "연 (매일 24시간)"},
  {value: 1, label: "주 1일"},
  {value: 2, label: "주 2일"},
  {value: 3, label: "주 3일"},
  {value: 4, label: "주 4일"},
  {value: 5, label: "주 5일"},
  {value: 6, label: "주 6일"},
  {value: 7, label: "주 7일"},
];

export const workHoursForDayValue: SelectType[] = [
  {value: 1, label: "01시간"},
  {value: 2, label: "02시간"},
  {value: 3, label: "03시간"},
  {value: 4, label: "04시간"},
  {value: 5, label: "05시간"},
  {value: 6, label: "06시간"},
  {value: 7, label: "07시간"},
  {value: 8, label: "08시간"},
  {value: 9, label: "09시간"},
  {value: 10, label: "10시간"},
  {value: 11, label: "11시간"},
  {value: 12, label: "12시간"},
  {value: 13, label: "13시간"},
  {value: 14, label: "14시간"},
  {value: 15, label: "15시간"},
  {value: 16, label: "16시간"},
  {value: 17, label: "17시간"},
  {value: 18, label: "18시간"},
  {value: 19, label: "19시간"},
  {value: 20, label: "20시간"},
  {value: 21, label: "21시간"},
  {value: 22, label: "22시간"},
  {value: 23, label: "23시간"},
  {value: 24, label: "24시간"},
];

export const pressureUnitValue: SelectType[] = [
  {value: 0, label: "MPa"},
  {value: 1, label: "kPa"},
  {value: 2, label: "mb"},
  {value: 3, label: "bar"},
  {value: 4, label: "psi"},
  {value: 5, label: "mmHg"},
  {value: 6, label: "inchHg"},
  {value: 7, label: "mmH2O"},
  {value: 8, label: "inchH2O"},
  {value: 9, label: "kg/cm²"},
  {value: 10, label: "Torr"},
  {value: 11, label: "Pa"},
  {value: 12, label: "cmHg"},
];

export const locationValue: SelectType[] = [
  {value: -1, label: "전체"},
  {value: 0, label: "내부"},
  {value: 1, label: "외부"},
];
